import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { getCheckedIdsArr } from 'utils';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { addMtrToContractChange } from '../AgreementsQueries';

const TITLE_ADD_MTR_ERROR = 'Отображение списка МТР';

export const useAddMtrAgreements = (
    agreementId: number,
    checkedIds: Record<string, boolean>,
    setCheckedIds: (value: Record<string, boolean>) => void,
    refreshAgreementMtr: () => void,
    setOpenModal: (value: boolean) => void,
    refreshFilters: () => void,
) => {
    const dispatch = useDispatch();

    const [isSubmittedAddMtr, setIsSubmittedAddMtr] = useState<boolean>(false);

    const [addMtrAgreementsData, addMtrAgreementsStatus, addMtrAgreementsError, addMtrAgreementsRequest] = useRequest({
        requestId: 'addMtrToContractChange',
        query: addMtrToContractChange,
        withEffect: false,
    });

    useEffect(() => {
        if (
            isSubmittedAddMtr &&
            addMtrAgreementsStatus === RequestStatus.SUCCESS &&
            addMtrAgreementsData?.uerAddMtrsToContractChange?.result
        ) {
            refreshAgreementMtr();
            refreshFilters();
            setIsSubmittedAddMtr(false);
            setOpenModal(false);
            setCheckedIds({});
        }
    }, [
        addMtrAgreementsData?.uerAddMtrsToContractChange?.result,
        addMtrAgreementsStatus,
        isSubmittedAddMtr,
        refreshAgreementMtr,
        refreshFilters,
        setCheckedIds,
        setOpenModal,
    ]);

    const handleAddMtrAgreements = useCallback(() => {
        const mtrRowIds = getCheckedIdsArr(checkedIds);

        dispatch(
            addMtrAgreementsRequest({
                contractChangeId: agreementId,
                mtrRowIds,
            }),
        );

        setIsSubmittedAddMtr(true);
    }, [addMtrAgreementsRequest, agreementId, checkedIds, dispatch]);

    const handleCloseErrorModalAddMtr = useCallback(() => {
        setIsSubmittedAddMtr(false);
    }, []);

    const handleCreateReportAddMtr = () => {
        ExportCSVReport(addMtrAgreementsData?.uerAddMtrsToContractChange?.validation);
    };

    return {
        titleAddError: TITLE_ADD_MTR_ERROR,
        addMtrAgreementsData: addMtrAgreementsData?.uerAddMtrsToContractChange,
        addMtrAgreementsStatus,
        addMtrAgreementsError,
        isSubmittedAddMtr,
        handleAddMtrAgreements,
        handleCloseErrorModalAddMtr,
        handleCreateReportAddMtr,
    };
};
